import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c9f4aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "headerContainer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon.png",
    style: {"width":"45px","margin-left":"-1px"}
  })
], -1))
const _hoisted_4 = { class: "logo2" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "logo2"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "headerFiller" }, null, -1))
const _hoisted_9 = { class: "headerActions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IosContrastIcon = _resolveComponent("IosContrastIcon")!
  const _component_IosRadioButtonOffIcon = _resolveComponent("IosRadioButtonOffIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: '/assets/LEXOH_LOGO_' + _ctx.$root.$i18n.locale.toUpperCase() + '_' + (_ctx.isDarkMode ? 'WHITE' : 'BLACK') + '.png'
        }, null, 8, _hoisted_5)
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.$root.$i18n.locale == 'fr' ? '/assets/logofr.png' : '/assets/logoen.png'
            }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          id: "buttonToggleModeDark",
          class: "buttonToggleMode",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.toggleDarkTheme(true);})
        }, [
          _createVNode(_component_IosContrastIcon)
        ]),
        _createElementVNode("button", {
          id: "buttonToggleModeLight",
          class: "buttonToggleMode active",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.toggleDarkTheme(false);})
        }, [
          _createVNode(_component_IosRadioButtonOffIcon)
        ]),
        _createElementVNode("a", {
          href: "javascript: void(0);",
          style: {"margin-right":"10px"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchLocale()))
        }, _toDisplayString(_ctx.$root.$i18n.locale == 'fr' ? 'EN' : 'FR'), 1),
        _createElementVNode("a", {
          href: "#",
          style: {"color":"#f03a3e","margin-left":"4px"},
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout()))
        }, _toDisplayString(_ctx.t('signout')), 1)
      ])
    ])
  ]))
}